import React, { useState } from 'react'
import styled from 'styled-components'
import { FileDoneOutlined, PlusOutlined } from '@ant-design/icons'
import { Col, Row, Space, Switch } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { MerchantPackageListReq, ActivateReq, MerchantPackageList } from 'Store/pos/types'
import { getMerchantPackageListAPI, activatePackageAPI } from 'Store/pos/api'
import { selectActionEvent, selectMerchantPackageList } from 'Store/pos/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/pos/actions'
import { ConfirmDailog } from 'Components/modal'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import EventModal from 'Components/modal/EventModal'
import theme, { MyTheme } from 'Components/common/Theme'
import { Link } from 'react-router-dom'
import { formatDateTime, getDiffDay } from 'helpers/format'
import PackageDetail from './PackageDetail'
import { merchantPermissionAPI, staffPermissionAPI } from 'Store/user/api'
import { getUserLogin } from 'helpers/account'
import { themeConfig } from 'config'
const MyLink: any = Link

type Props = {
  history: any
} & ReduxProps

const PackageList: React.FunctionComponent<Props> = props => {
  const { currentUser, actionEvent, history, merchantPackageList } = props
  const userInfo = getUserLogin()
  const isStaff = userInfo && userInfo?.store_type === 'merchant_staff'
  const dispatch = useDispatch()
  const [confirmDialog, setConfirmDialog] = useState(false)
  const [selected, setSelected] = useState({} as MerchantPackageList)
  const [drawer, setDrawer] = useState(false)

  const onGetMerchantPackageList = (): void => {
    const req: MerchantPackageListReq = {}
    dispatch(getMerchantPackageListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onActivatePackage = (id: number): void => {
    const req: ActivateReq = {
      id,
    }
    dispatch(activatePackageAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const gotoPackagePage = (): void => {
    history('/pos/packages')
  }

  const onOpenConfirm = () => {
    setConfirmDialog(true)
  }

  const onCloseConfirm = () => {
    setConfirmDialog(false)
  }

  const onClickSwitch = (data: MerchantPackageList) => {
    setSelected(data)
    onOpenConfirm()
  }

  const onClickDetail = (data: MerchantPackageList) => {
    setSelected(data)
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onGetPermission = (): void => {
    if (isStaff) {
      dispatch(staffPermissionAPI({}, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
    } else {
      dispatch(merchantPermissionAPI({}, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
    }
  }

  const PackageDetailDrawer = <PackageDetail id={selected.id} isShow={drawer} onClose={onCloseDrawer} />

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onChangeStatusSuccess = (): void => {
    clearEvent()
    onGetPermission()
    onGetMerchantPackageList()
  }

  const renderSwitchStatus = (activate: boolean, record: any) => {
    let remainDay = 0
    if (record.end_date != '') {
      remainDay = getDiffDay(record.end_date || '').toFixed(0)
    } else {
      remainDay = record.day
    }
    return (
      <Switch
        loading={actionEvent.IsLoading}
        checked={activate}
        onChange={() => onClickSwitch(record)}
        disabled={activate || remainDay <= 0}
      />
    )
  }

  const renderActionButton = (activate: boolean, record: MerchantPackageList) => {
    return (
      <ActionButton
        text=""
        icon={<FileDoneOutlined />}
        label="รายละเอียดแพ็กเกจ"
        action="edit"
        onClick={(event: any) => {
          event.stopPropagation()
          onClickDetail(record)
        }}
      />
    )
  }

  const renderRemainDay = (val: any, record: any) => {
    const canRenew = record.is_renew === true
    let remainDay = 0
    if (record.end_date != '') {
      remainDay = getDiffDay(record.end_date || '').toFixed(0)
    } else {
      remainDay = record.day
    }

    let remainTxt = `${remainDay} วัน` as any
    if (remainDay <= 0) {
      remainTxt = <DeadlineText>{remainDay < 0 ? 0 : Math.abs(remainDay)} วัน </DeadlineText>
    } else if (remainDay <= 7) {
      remainTxt = <WarningText>7 วัน </WarningText>
    }

    return (
      <Space>
        {remainTxt}
        {canRenew && (
          <>
            <DividerGrey>|</DividerGrey>
            <LinkText to={`/pos/packages/${record.id}`}>ต่ออายุแพ็กเกจ</LinkText>
          </>
        )}
      </Space>
    )
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return index + 1
      },
      width: '60px',
    },
    {
      title: 'ชื่อแพ็กเกจ',
      dataIndex: 'name',
      key: 'name',
      // eslint-disable-next-line react/display-name
      render: (val: string, record: any) => <LinkNo onClick={() => onClickDetail(record)}>{val}</LinkNo>,
    },
    {
      title: 'วันที่เริ่มใช้งาน',
      dataIndex: 'start_date',
      key: 'start_date',
      render: (val: string) => (val !== '' ? formatDateTime(val) : '') || '-',
    },
    {
      title: ' วันที่หมดอายุ',
      key: 'end_date',
      dataIndex: 'end_date',
      render: (val: string) => (val !== '' ? formatDateTime(val) : '') || '-',
    },
    {
      title: 'จำนวนวันใช้งาน',
      key: 'day',
      dataIndex: 'day',
    },
    {
      title: ' วันใช้งานคงเหลือ',
      key: 'status',
      dataIndex: 'status',
      render: renderRemainDay,
    },
    {
      title: 'สถานะเปิดใช้งาน',
      key: 'activate',
      dataIndex: 'activate',
      render: renderSwitchStatus,
    },
    // {
    //   title: '',
    //   key: 'detail',
    //   dataIndex: 'detail',
    //   width: '50px',
    //   render: renderActionButton,
    // },
  ]

  const LoadingModal = (
    <EventModal
      event={[actionEvent]}
      enable={true}
      successCalback={onChangeStatusSuccess}
      errorCalback={clearEvent}
    />
  )

  const getActivePackage = () => {
    return (
      merchantPackageList &&
      merchantPackageList.data &&
      merchantPackageList.data.find(item => item.activate === true)
    )
  }

  const getMpdalWording = () => {
    const currentActive = getActivePackage()
    const isC = selected.name === 'แพ็กเกจ C'
    const currentPackageName = currentActive?.name || 'แพ็จเกจปัจจุบัน'

    //first activate
    if (selected.start_date == '' || selected.end_date == '') {
      return (
        <BulletErrorText>
          - การนับวันใช้งานจะถูกนับทันทีหลังจากที่คุณเปิดใช้งานแพ็กเกจนี้ กรุณาทำการ
          &quot;ตั้งค่าเริ่มต้น&quot; ในการใช้งานที่เครื่อง Terminal เพื่อการใช้งานที่สมบูรณ์ <br />
          {isC && (
            <span>
              - จำนวนของสต๊อกจะเกิดความคลาดเคลื่อนได้ ทางร้านจะต้องดำเนินการจัดการสต๊อกสินค้าใหม่ทั้งระบบ{' '}
              <br />
            </span>
          )}
          - หลังจากคุณเปิดใช้{selected.name} วันใช้งานของ
          {currentPackageName} จะหมดอายุทันที จะส่งผลให้{currentPackageName} ไม่สามารถใช้งานได้อีก
          <br />
          <br />
          <BulletGrey>
            หากมีข้อสงสัยเพิ่มเติม <br />
            สามารถติดต่อสอบถามได้ที่บริการผู้ช่วยส่วนตัว {themeConfig.title.contactNumber} <br />
            ระหว่างวันจันทร์-วันศุกร์ เวลา 09:00 - 18:00 น. <br />
            และวันเสาร์-วันอาทิตย์ เวลา 10:00 - 18:00 น.
          </BulletGrey>
        </BulletErrorText>
      )
    }

    //inactivate
    if (selected.activate) {
      return 'การปิดใช้งานแพ็จเกจปัจจุบัน จะทำให้เครื่อง Terminal ทุกเครื่องที่ใช้งานแพ็กเกจนี้ ไม่สามารถใช้ได้การนับวันใช้งานจะยังคงถูกนับ เนื่องจากทางร้านค้าได้ทำการเปิดใช้งานครั้งแรกไปแล้ว'
    }

    return (
      <BulletErrorText>
        - หลังจากคุณเปิดใช้{selected.name} วันใช้งานของ
        {currentPackageName} จะหมดอายุทันที จะส่งผลให้{currentPackageName} ไม่สามารถใช้งานได้อีก
        <br />
        - การเปลี่ยนแปลงแพ็จเกจ จะส่งผลให้เครื่อง Terminal ทุกเครื่องที่ใช้งานอยู่ในปัจจุบันไม่สามารถใช้งานได้
        ร้านค้าจะต้องทำการตั้งค่าการใช้งานใหม่
        <br />- จำนวนของสต๊อกจะเกิดความคลาดเคลื่อนได้ ทางร้านค้าอาจต้องดำเนินการ จัดการสต๊อกสินค้าใหม่ทั้งระบบ{' '}
        <br /> <br />
        <BulletGrey>
          หากมีข้อสงสัยเพิ่มเติม <br />
          สามารถติดต่อสอบถามได้ที่บริการผู้ช่วยส่วนตัว 02-091-5999 <br />
          ระหว่างวันจันทร์-วันศุกร์ เวลา 09:00 - 18:00 น. <br />
          และวันเสาร์-วันอาทิตย์ เวลา 10:00 - 18:00 น.
        </BulletGrey>
      </BulletErrorText>
    )
  }

  const ConfirmActivateModal = (
    <ConfirmDailog
      title={<ErrorText>คำเตือนการเปลี่ยนแปลงการใช้งาน !!</ErrorText>}
      description={getMpdalWording()}
      isShow={confirmDialog}
      handleOk={() => onActivatePackage(selected.id)}
      handleCancel={onCloseConfirm}
      confirmBtnTxt="ยืนยันการเปลี่ยนแปลง"
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="end" align="bottom">
        <MyCol>
          <Space size="middle">
            <PrimaryButton text="ซื้อแพ็กเกจเพิ่ม" icon={<PlusOutlined />} onClick={gotoPackagePage} />
          </Space>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  return (
    <>
      {FilterContent}
      <TableListPage
        columns={columns}
        datas={merchantPackageList.data}
        isLoading={merchantPackageList.event.IsLoading}
      />
      {LoadingModal}
      {ConfirmActivateModal}
      {PackageDetailDrawer}
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    actionEvent: selectActionEvent(state),
    merchantPackageList: selectMerchantPackageList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const LinkNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fontFamily.bold};
  color: ${theme.colors.primary};
`

const WarningText = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.warning};
`

const DeadlineText = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const LinkText = styled(MyLink)`
  text-decoration: underline;
  cursor: pointer;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.drakGrey};
`

const DividerGrey = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const ErrorText = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const BulletErrorText = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
  text-align: left;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const BulletGrey = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  text-align: center;
`
export default connect(mapStateToProps)(PackageList)
